<p-fieldset [style]="{'border':'1px solid #000000'}">
    <p-header><b>Note</b></p-header>
    <ul>
        <li>All the fields marked with <span class="doctor-form-req">*</span> are compulsory .</li>

        <li *ngIf="!othermedical">PIN and eSignature are required to prescribe and validate medications .</li>

        <li *ngIf="save">Save button will only save textual data and not password, pin and media files .</li>
        
        <li *ngIf="localSave">Clicking on save button will save the data on your computer .</li>

        <li>Please use the latest version of Google Chrome, Mozilla Firefox, Microsoft Edge, Safari.</li>

        <li>Please use your computer for filling the form.</li>

        <li *ngIf="!doctorEdit || !othermedical">A guide to fill this application is available 
            <button class="ui-button-info ui-button-rounded" (click)="openFormLink()" pButton label="Click here"></button>   .
        </li>
            <!-- <a target="_blank" [href]="doctorregistration">here</a> -->
    </ul>
</p-fieldset>
